import get from 'lodash.get';
import { updateConfigValues } from './actions/config';
import getStore from './index';
import { useDispatch } from 'react-redux';
import { useConfig } from './reducers/config';

/**
 * @deprecated use the useInitialSoftwareNumber hook, instead.
 */
export function getInitialSoftwareNumber() {
  const state = getStore().getState();
  return get(state, 'config.softwareNumber');
}

export const useInitialSoftwareNumber = () => {
  const { softwareNumber } = useConfig();

  return softwareNumber;
};

/**
 * @deprecated use the useCurrentSoftwareNumber hook, instead.
 */
export function getCurrentSoftwareNumber() {
  const state = getStore().getState();
  return get(
    state,
    'config.softwareNumberOverride',
    getInitialSoftwareNumber(),
  );
}

export const useCurrentSoftwareNumber = () => {
  const { softwareNumber, softwareNumberOverride } = useConfig();

  return softwareNumberOverride || softwareNumber;
};

export function overrideSoftwareNumber(softwareNumberOverride) {
  const config = { softwareNumberOverride };
  getStore().dispatch(updateConfigValues(config));
}

export const useOverrideSoftwareNumber = (softwareNumberOverride: number) => {
  const dispatch = useDispatch();
  const config = { softwareNumberOverride };
  dispatch(updateConfigValues(config));
};
